<template>
  <div class="cms-wrap" :style="styles"><slot></slot></div>
</template>

<script>
export default {
  name: 'ZtWrap',
  props: {
    height: { type: [String, Number], default: '' },
  },

  computed: {
    styles() {
      const height = this.height
      return { height }
    },
  },
}
</script>
